import React from "react";

const Privacy = (props) => {
  return (
    <div class="article">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1>Mentions légales</h1>
            <div class="col-xs-12">
              <h2>1. Éditeur du site</h2>
              <p>
                Le site davoyage.com est édité par <strong>David Imirzian</strong>,
                exerçant sous le nom commercial <strong>Davoyage</strong>,
                Entrepreneur Individuel.
                <br />
                Siège social : 10 rue de Nazareth, 69003 Lyon, France
                <br />
                SIREN : 479 817 249
                <br />
                SIRET (établissement principal) : 479 817 249 00010
                <br />
                Numéro de TVA intracommunautaire : FR83479817249
                <br />
                Immatriculation VTC (Atout France) : EVTC069140133
                <br />
                Directeur de la publication : David Imirzian
                <br />
                Contact : <a href="mailto:contact@davoyage.com">contact@davoyage.com</a> — 06 60 26 53 36
              </p>

              <h2>2. Hébergement</h2>
              <p>
                Le site est hébergé par Amazon Web Services EMEA SARL,
                38 avenue John F. Kennedy, L-1855 Luxembourg.
              </p>

              <h2>3. Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, logos,
                structure) est protégé par le droit d'auteur. Toute
                reproduction, représentation ou diffusion, totale ou
                partielle, sans autorisation préalable de Davoyage, est
                interdite et constitutive de contrefaçon.
              </p>

              <h2>4. Données personnelles</h2>
              <p>
                Les informations recueillies via le formulaire de devis
                (nom, prénom, email, téléphone, adresses de trajet) sont
                nécessaires au traitement de votre demande et ne sont ni
                vendues ni cédées à des tiers en dehors des prestataires
                strictement nécessaires à la prestation (paiement,
                géolocalisation des trajets).
              </p>
              <p>
                Conformément au Règlement Général sur la Protection des
                Données (RGPD) et à la loi Informatique et Libertés, vous
                disposez d'un droit d'accès, de rectification, de
                suppression et d'opposition aux données vous concernant.
                Pour exercer ce droit, contactez{" "}
                <a href="mailto:contact@davoyage.com">contact@davoyage.com</a>.
              </p>

              <h2>5. Médiation de la consommation</h2>
              <p>
                Conformément à l'article L.616-1 du Code de la
                consommation, tout client consommateur a le droit de
                recourir gratuitement à un médiateur de la consommation
                en vue de la résolution amiable d'un litige qui
                l'opposerait à Davoyage.
              </p>

              <h2>6. Droit applicable et litiges</h2>
              <p>
                Le présent site et ses conditions d'utilisation sont
                soumis au droit français. En cas de litige, et à défaut
                de résolution amiable, les tribunaux de Lyon seront
                seuls compétents.
              </p>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
